// HTML for the Results table (DataTables takes cells and titles as HTML).
// Answers and question labels are typed by people, so every piece of them is
// escaped here; nothing a respondent typed can become markup or script.

export const escapeHtml = (value) => String(value ?? "")
    .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;").replace(/'/g, "&#39;");

// A column's question text (its title is escaped HTML for DataTables).
export const columnLabel = (col) => (col.label !== undefined ? col.label : col.title);

// A spreadsheet cell that starts with = + - @ (or a tab / return) could run as
// a formula when a CSV is opened; a leading ' makes it text. Plain numbers
// such as -5 are left alone.
export const spreadsheetSafe = (value) => {
    const text = String(value ?? "");
    return /^[=+\-@\t\r]/.test(text) && !/^[-+]?\d+(\.\d+)?$/.test(text) ? `'${text}` : text;
};

const piece = (v) => escapeHtml(v !== null && typeof v === "object" ? JSON.stringify(v) : v);

// One answer as table-cell HTML. apiBase prefixes the owner-only file links.
export function answerCellHtml(answer, apiBase = "") {
    if (!answer || !answer.answer) return "-";

    if (answer.signature) {
        const text = escapeHtml(answer.answer);
        return `<img class="signature-thumb" src="${escapeHtml(apiBase + answer.signature.url)}" alt="${text}" title="${text}" loading="lazy">`;
    }

    if (answer.document) {
        return `<a href="${escapeHtml(apiBase + answer.document.url)}" target="_blank" rel="noreferrer">${escapeHtml(answer.answer)}</a>`;
    }

    const value = String(answer.answer);
    try {
        const parsed = JSON.parse(value);
        // Lists (Multiple Select, Ranking...): one item per line
        if (Array.isArray(parsed)) {
            return parsed.map(item => `<div style="white-space: nowrap;">${piece(item)}</div>`).join("");
        }
        // Address, Choice Matrix...: "key: value" per line
        if (parsed !== null && typeof parsed === "object") {
            return Object.entries(parsed)
                .map(([k, v]) => `<div style="white-space: nowrap;">${piece(k)}: ${piece(v)}</div>`)
                .join("");
        }
    } catch (e) {
        // Plain text is shown as typed. (Commas used to become line breaks,
        // splitting one answer.)
    }

    const isDateOrTime = /^\d{4}-\d{2}-\d{2}$/.test(value)
        || /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value)
        || /^\d{2}:\d{2}$/.test(value);
    return `<div style="white-space: ${isDateOrTime ? "nowrap" : "normal"};">${escapeHtml(value)}</div>`;
}
